import React, { useEffect, useRef, useState } from 'react';
import Layout from '../Layout';
import { Image } from 'react-bootstrap';
import 'animate.css';

const AboutUs = () => {

    const ref = useRef(null);
    const [inView, setInView] = useState(false);


    return (
        <Layout>


            <section className='pages-container add_height'>
                <h1 className='carousel-text-h1 wow animate__ animate__fadeIn  animated' data-wow-duration="1.4s">Compassion, Inclusivity <br className='hide' />and Actionable Change.</h1>
            </section>

            {/* Services Section */}
            <section className="section-container" style={{ paddingBottom: '0px' }}>

                <div className="services-section">
                    <h4 className="pageh4 mb-3  padding_x wow animate__animated animate__fadeInUp" data-wow-duration="1.5s">Bethel Community Foundation Canada was founded on the principle of service—uplifting and supporting those often overlooked by conventional systems.</h4>
                    <div className="mb-4 w50">
                        <p className=" mb-4 mx-auto text-center wow animate__animated animate__fadeInUp" data-wow-duration="1.4s">
                            Our mission is simple yet impactful: to foster equity, opportunity, and wellness within BIPOC communities across Alberta, Canada and Globally.
                        </p>
                    </div>
                </div>
            </section>


            <section className="section-container" style={{ paddingTop: '0px' }}>
                <div className=' wow animate__animated animate__fadeInUp' data-wow-duration="1s">
                    <Image src="/images/about.png" alt="Hero" className="img-fluid box-img wow animate__animated animate__fadeInUp" data-wow-duration="1.2s" />
                    <div className='secTwo'>
                        <p className="paragraph-title2 wow animate__animated animate__fadeInUp" data-wow-duration="1.5s">With a team that bridges professional expertise and lived experience, we mobilize resources to meet the tangible needs of real people. From emergency shelter to long-term mentoring, our work represents a blueprint for community-led transformation.</p>
                    </div>
                </div>
            </section>

            <section className="section-container">

                <div className="about-section">


                    <div className="abt-box margin_d wow animate__animated animate__fadeInUp" data-wow-duration="1.4s">

                        <div className='abt-box-content'>
                            <h3 className='abt-title'>Vision Statement</h3>
                            <p>Rooted in equity. Thriving in dignity. Belonging for all.</p>
                        </div>
                        <Image src="/images/vision.jpg" alt="Hero" className="img-fluid serv-img" />
                    </div>

                    <div className="abt-box reverse_flex wow animate__animated animate__fadeInUp" data-wow-duration="1.2s">
                        <Image src="/images/mission.png" alt="Hero" className="img-fluid serv-img" />
                        <div className='abt-box-content'>
                            <h3 className='abt-title'>Mission Statement</h3>
                            <p>BCFC empowers BIPOC individuals and vulnerable communities in Canada and globally by providing inclusive support services, mentorship, mental wellness resources, and pathways to integration and self-sufficiency. We foster equitable access, dignity, and resilience through community-led initiatives.</p>

                        </div>
                    </div>



                </div>

            </section>





        </Layout>
    );
};

export default AboutUs;